import type { LoaderFunctionArgs } from '@remix-run/node';
import { getRecentlyViewedArticles } from '~/modules/articles/api/get-recently-viewed-articles.server';

export const loader = async ({ context }: LoaderFunctionArgs) => {
    const [recentlyViewedArticles] = await Promise.all([
        getRecentlyViewedArticles(context),
    ]);

    return {
        recentlyViewedArticles,
    };
};

export const HREF_RECENTLY_VIEWED_ARTICLES =
    '/remix-api/articles/get-recently-viewed-articles';
